import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { configure } from 'vue-gtag'
import * as Sentry from '@sentry/vue'

import { WebEnvironmentConfigService } from './services/env-config.service'

async function bootstrap() {
  const app = createApp(App)
  const envConfigService = new WebEnvironmentConfigService()
  Sentry.init({
    app,
    dsn: await envConfigService.getSentryDsn(),
    sendDefaultPii: true,
    environment: await envConfigService.getEnvironmentName(),
  })
  const gaMeasurementId = await envConfigService.getGaMeasurementId()

  configure({
    tagId: gaMeasurementId,
  })
  app.use(createPinia())
  app.use(router)
  app.mount('#app')
}

bootstrap()
